//! TODO: Move those functions to modules/chat-channels/utils/*

import { ChatChannelType, IChatConversation } from 'src/@types/chat';
import { ConversationMessageContentType } from 'src/@types/conversation';

export const isP2pConversation = ({ type, p2p }: IChatConversation) =>
  type === ChatChannelType.TEXT && !!p2p;

export const isGroupConversation = ({ type, p2p }: IChatConversation) =>
  type === ChatChannelType.TEXT && !p2p;

export const isVoiceConversation = ({ type }: IChatConversation) =>
  type === ChatChannelType.VOICE;

export const getP2PConversationPair = (conversation: IChatConversation) =>
  conversation.participants;

export const isThreadConversation = (conversation: IChatConversation) =>
  !!conversation.parentId;

export const chatFileType = (type: string) => {
  if (type.startsWith('image')) return ConversationMessageContentType.IMAGE;
  if (type.startsWith('video')) return ConversationMessageContentType.VIDEO;
  if (type.startsWith('audio')) return ConversationMessageContentType.AUDIO;
  return ConversationMessageContentType.FILE;
};
